export default {
  login: {
    method: 'post',
    url: '/v1/system/login'
  },
  captcha: {
    method: 'post',
    url: '/v1/basic/captcha/create'
  },
  resetEmpPwd: {
    method: 'post',
    url: '/v1/basic/captcha/resetEmpPwd'
  },
  getPerSettings: {
    method: 'get',
    url: '/v1/basic/per/settings'
  },
  getDomainByPhone: {
    method: 'post',
    url: '/v1/basic/tenant/register/domain/phone'
  },
  getRestPwdPhoneCode: {
    method: 'post',
    url: '/v1/basic/captcha/getRestPwdPhoneCode'
  }
}
